import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 1.5rem 0;
  text-align: center;

  p {
    margin: 0;
    color: ${Styles.color.grey.one};
  }
`;

export const Title = styled.h4`
  margin: 0 0 0.2rem 0;
  color: ${Styles.color.grey.one};
  font-size: 1.1rem;
`;
